(() => {
  const menuSelector = '[data-tf-overflow-menu]';
  const toggleSelector = '[data-tf-overflow-toggle]';

  const closeMenu = (menu) => {
    menu.classList.remove('is-open');
    menu.querySelector(toggleSelector)?.setAttribute('aria-expanded', 'false');
  };

  const closeOtherMenus = (currentMenu) => {
    document.querySelectorAll(`${menuSelector}.is-open`).forEach((menu) => {
      if (menu !== currentMenu) closeMenu(menu);
    });
  };

  const initOverflowMenus = (root = document) => {
    root.querySelectorAll(menuSelector).forEach((menu) => {
      const toggle = menu.querySelector(toggleSelector);
      if (!toggle || toggle.dataset.tfOverflowReady === 'true') return;

      toggle.dataset.tfOverflowReady = 'true';
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = !menu.classList.contains('is-open');

        closeOtherMenus(menu);
        menu.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest(menuSelector)) return;
    document.querySelectorAll(`${menuSelector}.is-open`).forEach(closeMenu);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${menuSelector}.is-open`).forEach(closeMenu);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initOverflowMenus(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initOverflowMenus());
  } else {
    initOverflowMenus();
  }
})();
